export const CollectionCategoryPermissionKeys = Object.freeze({
  LIST: {
    VIEW: 'product.collectionCategory.list-view',
    UPDATE: 'product.collectionCategory.list-update',
    DELETE: 'product.collectionCategory.list-delete',
  },
});
